import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/features/constants';

import { Pagination } from '../types';

// TODO only for mocks, remove in future
export const generateId = state =>
  `ТИС${(state.data.length + 1).toString().padStart(6, '0')}`;

export const infiniteQueryOptions = {
  initialPageParam: { page: DEFAULT_PAGE, pageSize: DEFAULT_PAGE_SIZE },
  getNextPageParam: (lastPage, _, lastPageParam) => {
    if (!lastPage.length || lastPage.length < lastPageParam.pageSize) {
      return;
    }
    return {
      page: lastPageParam.page + 1,
      pageSize: lastPageParam.pageSize,
    };
  },
};

export const infiniteQueryOptionsFn = ({
  page,
  pageSize,
}: Partial<Pagination> = {}) => ({
  initialPageParam: {
    page: page || DEFAULT_PAGE,
    pageSize: pageSize || DEFAULT_PAGE_SIZE,
  },
  getNextPageParam: (lastPage, _, lastPageParam) => {
    if (!lastPage.length || lastPage.length < lastPageParam.pageSize) {
      return;
    }
    return {
      page: lastPageParam.page + 1,
      pageSize: lastPageParam.pageSize,
    };
  },
});

export const findById = (
  id: string,
  {
    key = 'id',
    selector,
    // @ts-ignore
  }: { key: string | ((el: any) => boolean); selector: any },
) => {
  try {
    let data: any;

    const filterFn = typeof key === 'function' ? key : p => p[key] === id;

    if (selector?.data?.pages) {
      let pages = selector?.data?.pages?.flat();

      if (Array.isArray(pages?.[0]?.items)) {
        pages = pages.reduce((acc, page) => acc.concat(page.items), []);
      }

      data = pages?.find(filterFn);
    } else if (Array.isArray(selector?.data)) {
      data = selector?.data?.find(filterFn);
    }

    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const cachedItemByIdSelector =
  (
    api: string,
    endpoint: string | string[],
    key: string | ((el: any) => boolean) = 'id',
  ) =>
  (id: string) =>
  (state: any) => {
    const queries = state?.[api]?.queries;
    let data: any;
    if (queries) {
      for (const query in queries) {
        if ([endpoint].flat().some(name => query.includes(name))) {
          data = findById(id, { key, selector: queries[query] });
        }
      }
    }

    return data;
  };

export function paramsWithPageSize(params: any, pageSize: number) {
  return { ...params, pageSize };
}
